import React from 'react'

 const About = () => {
    return (
       <div className="container">
           <h1>About this App.</h1>
           <p>App to search github users</p>
           <p>Version: 1.0.0</p>
       </div>
    )
}
export default About
